import React from 'react'
import { Table, Thead, Tr, Th, Td, Tbody } from '@chakra-ui/react'
import _ from 'lodash'
import moment from 'moment'
import { useTranslation } from 'react-i18next'

export default function EstimateBillDetailLists({ history }) {
  const { t } = useTranslation()
  const genEstimateBillLists = () =>
    _.map(history, (_history, index) => (
      <Tr key={_history._id}>
        {/* <Td>{index + 1}</Td> */}
        <Td>
          {' '}
          {moment(_history.date).format('DD/MM/YYYY')}{' '}
          <span>
            {_history.holiday > 0 ? (
              <span className="text-xs text-green-400">
                {t('dateTime.restDay')}
              </span>
            ) : (
              <span className="text-xs text-red-300">
                {t('dateTime.normalDay')}
              </span>
            )}
          </span>
        </Td>
        <Td>
          {_history.all === 0 ? (
            <div> - </div>
          ) : (
            <>
              {parseFloat(_history.all).toFixed(2) + ' '} {t('counter.unit')}
            </>
          )}{' '}
        </Td>
        <Td>
          {' '}
          {_history.onPeak === 0 ? (
            <div> - </div>
          ) : (
            <>
              {parseFloat(_history.onPeak).toFixed(2) + ' '}
              {t('counter.unit')}
            </>
          )}{' '}
        </Td>
        <Td>
          {' '}
          {_history.offPeak === 0 ? (
            <div> - </div>
          ) : (
            <>
              {parseFloat(_history.offPeak).toFixed(2) + ' '}
              {t('counter.unit')}
            </>
          )}{' '}
        </Td>
        <Td>
          {' '}
          {_history.holiday === 0 ? (
            <div> - </div>
          ) : (
            <>
              {parseFloat(_history.holiday).toFixed(2) + ' '}
              {t('counter.unit')}
            </>
          )}{' '}
        </Td>
        <Td>
          {parseFloat(_history.power).toFixed(2) + ' '}
          {t('electricBill.baht')}
        </Td>
      </Tr>
    ))
  return (
    <div>
      <Table size="sm" variant="striped" className="whitespace-no-wrap">
        <Thead>
          <Tr>
            {/* <Th>#</Th> */}
            <Th>{t('dateTime.date')}</Th>
            <Th> {t('utility.total')}</Th>
            <Th>{t('electricBill.onPeak')}</Th>
            <Th>{t('electricBill.offPeak')}</Th>
            <Th>{t('electricBill.Holiday')}</Th>
            <Th>{t('electricBill.electricBillOfDay')}</Th>
          </Tr>
        </Thead>
        <Tbody>{genEstimateBillLists()}</Tbody>
      </Table>
    </div>
  )
}
